import { useEffect, useRef } from 'react';

// Both WhatsApp channels share the visible viewport, including the mobile keyboard.
export default function useWhatsappViewport({ chatOpen, messagesRef, nearBottomRef }) {
  const chatOpenRef = useRef(chatOpen);
  chatOpenRef.current = chatOpen;
  useEffect(() => {
    const root = document.documentElement;
    let frame;
    const apply = () => {
      const phone = window.innerWidth <= 768;
      document.body.classList.toggle('wa-mobile-page', phone);
      document.body.classList.toggle('wa-chat-open', phone && chatOpenRef.current);
      if (!phone) return;
      const viewport = window.visualViewport;
      root.style.setProperty('--wa-vvh', `${Math.round(viewport ? viewport.height : window.innerHeight)}px`);
      root.style.setProperty('--wa-vvtop', `${Math.round(viewport ? viewport.offsetTop : 0)}px`);
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const container = messagesRef.current;
        if (container && nearBottomRef.current) container.scrollTop = container.scrollHeight;
      });
    };
    apply();
    window.addEventListener('resize', apply);
    const viewport = window.visualViewport;
    viewport?.addEventListener('resize', apply);
    viewport?.addEventListener('scroll', apply);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', apply);
      viewport?.removeEventListener('resize', apply);
      viewport?.removeEventListener('scroll', apply);
      document.body.classList.remove('wa-mobile-page', 'wa-chat-open');
      root.style.removeProperty('--wa-vvh');
      root.style.removeProperty('--wa-vvtop');
    };
  }, [messagesRef, nearBottomRef]);

  useEffect(() => {
    document.body.classList.toggle('wa-chat-open', window.innerWidth <= 768 && chatOpen);
  }, [chatOpen]);
}
